// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1lVyt","requiredAsterisk":"Info_requiredAsterisk__2TtXS"};